import API from './config'

export const XmlAssetAPI = {

    async getAll() {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/xmlAssets/getAll`, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async save(xmlSpAsset) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = xmlSpAsset.id ?
                await API.put(`/xmlAssets/update`, xmlSpAsset, config)
                :
                await API.post(`/xmlAssets/create`, xmlSpAsset, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async delete(xmlAssetId) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response =
                await API.delete(`/xmlAssets/delete/${xmlAssetId}`, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

}